// extracted by mini-css-extract-plugin
export default {"root":"FallbackPage_root__9ycu+","content":"FallbackPage_content__7+HJm"};